class Webcams {
    constructor() {

        this.webcamShots = [...document.querySelectorAll('[data-webcam-shot]')]

        this.init();
    }

    init() {

        if (!this.webcamShots.length) {
            return
        }

        this.webcamShots.map(shot => {

            const newUrl = this.addTimeStamp(shot.dataset.src)

            if (shot.nodeName === 'IMG') {
                shot.src = newUrl
            } else {
                shot.style.setProperty('--webcam-shot-src', `url(${newUrl})`)
            }

        })

    }

    addTimeStamp(src) {
        if (src) {
            const url = new URL(src)
            url.searchParams.set('t', Date.now())
            return url.href
        }
    }

}

export default Webcams